import { Component, OnInit, input, output } from '@angular/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as Moment from 'moment';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-monthSelect',
  templateUrl: './monthSelect.component.html',
  styleUrls: ['./monthSelect.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  standalone: false,
})
export class MonthSelectComponent implements OnInit {
  readonly mostrar = input(false);
  public mes = new Date();
  readonly onChange = output<Date>();

  constructor() {}

  public setMonthAndYear(
    normalizedMonthAndYear: Moment.Moment,
    datepicker: MatDatepicker<Moment.Moment>,
  ) {
    const m = normalizedMonthAndYear.month();
    const y = normalizedMonthAndYear.year();
    const date = new Date(y, m, 1, 7, 0, 0, 0);
    this.mes = date;
    datepicker.close();
    this.onChange.emit(date);
  }

  //

  async ngOnInit(): Promise<void> {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    date.setDate(1);
    date.setHours(7);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    this.mes = date;
    this.onChange.emit(date);
  }

  ngOnDestroy(): void {}
}
